import * as React from "react";
import HomeContainer from "../containers/home-container";

export default function HomePage() {
  return <HomeContainer></HomeContainer>;
}
